import { render, staticRenderFns } from "./IntentEditPage.vue?vue&type=template&id=00478a3c"
import script from "./IntentEditPage.vue?vue&type=script&lang=js"
export * from "./IntentEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports